var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Union_3","data-name":"Union 3","d":"M13.082,15.91,2.829,26.163,0,23.334,10.253,13.082,0,2.829,2.829,0,13.082,10.253,23.334,0l2.829,2.829L15.91,13.082,26.163,23.334l-2.829,2.829Z"}));
}

Cross.defaultProps = {"width":"26.163","height":"26.163","viewBox":"0 0 26.163 26.163"};

module.exports = Cross;

Cross.default = Cross;
